module.exports = __webpack_public_path__ + "static/media/Montserrat-BlackItalic.87d5d270.woff";